module.exports = "<app-nav-header></app-nav-header>\n\n<router-outlet></router-outlet>\n"